






























import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/tooltip'

import Mixins from './mixin'

export default Mixins.extend({
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tmrUpdate: 0,
      options: {
        series: [
          {
            name: 'name',
            type: 'gauge',
            radius: '90%',
            min: 0,
            max: 100,
            splitNumber: 5,
            axisLine: {
              lineStyle: {
                width: 3,
                color: [
                  [0.11, 'rgb(240, 175, 36)'],
                  [0.83, 'rgb(73, 172, 43)'],
                  [0.94, 'rgb(240, 175, 36)'],
                  [1, 'red'],
                ],
              },
            },
            axisLabel: {
              textStyle: {
                fontSize: 5,
              },
              distance: 5,
              color: '',
            },
            axisTick: {
              length: 3,
              lineStyle: {
                color: 'auto',
                width: 1,
              },
            },
            splitLine: {
              length: 6,
              lineStyle: {
                color: 'auto',
                width: 2,
              },
            },
            pointer: {
              width: 2,
              length: '90%',
            },
            detail: {
              formatter: function(value: number) {
                return value.toFixed(0)
              },
              offsetCenter: [0, '80%'],
              shadowBlur: 5,
              textStyle: {
                fontWeight: 'bolder',
                fontSize: 9,
              },
            },
            data: [{ value: 50, name: '' }],
          },
        ],
      },
    }
  },

  computed: {
    tagValue(): number {
      if (typeof this.model.attributes == undefined) {
        return -999
      }
      const tag = this.tags[this.model.attributes.tag]
      if (tag) {
        this.options.series[0].data = [{ value: tag.value, name: '' }]
        return tag.value
      }

      return -999
    },
  },

  methods: {},
  watch: {
    tagValue: function(val: number) {
      this.options.series[0].data[0] = { value: val, name: '' }
    },
  },

  created() {
    this.parseInput()
    this.options = Object.assign(
      this.options,
      this.value.attributes.chartOptions
    )

    if (this.value.options) {
      // Parsing snapshot value
      this.options = JSON.parse(JSON.stringify(this.value.options))
    } else {
      // this.cyclicUpdate(true)
      // console.log(this.model)
    }
  },

  beforeDestroy() {
    clearTimeout(this.tmrUpdate)
  },
})
